import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtenteProvisioningService {
  private _checkValidityUrl = 'api/CodiceFiscale/check';

  constructor(
    private http: HttpClient,
  ) {}

  checkCodiceFiscaleValidity(personaFisicaBaseInfo: any) {
    return this.http.post(this._checkValidityUrl, personaFisicaBaseInfo);
  }
}
